'use client';

import ScreenReaderMessage from '@atoms/ScreenReaderMessage/ScreenReaderMessage';
import { StyledSpinner, StyledSpinnerWrapper } from './Spinner.styles';
import { RefObject, useEffect, useState } from 'react';
import LottiePlayer from '@molecules/LottiePlayer/LottiePlayer';
import { IntersectionObserverHookRefCallback } from 'react-intersection-observer-hook';

export type SpinnerSizeType = 32 | 20 | 16;
type SpinnerColorType = 'black' | 'primary' | 'white';

interface Props {
  color?: SpinnerColorType;
  className?: string;
  title?: string;
  size?: SpinnerSizeType;
  ref?: RefObject<HTMLDivElement | null> | IntersectionObserverHookRefCallback;
}

const Spinner = ({ color = 'black', className, title, size = 20, ref }: Props) => {
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    (async () => {
      const fileName = `loader_${size}px_${color}.json`;
      const loadedAnimation = await import(`./animations/${fileName}`);
      setAnimation(loadedAnimation);
    })();
  }, [size, color]);

  return (
    <StyledSpinnerWrapper ref={ref} className={className}>
      <StyledSpinner data-testid="spinner" $size={size}>
        {animation && <LottiePlayer animationData={animation} data-testid="spinner-icon" />}
      </StyledSpinner>

      {title && <ScreenReaderMessage>{title}</ScreenReaderMessage>}
    </StyledSpinnerWrapper>
  );
};

export default Spinner;
